import type { App } from "@open-booking/server";
import type { UpdateUserPayload } from "@open-booking/shared";
import { createApi } from "@reduxjs/toolkit/query/react";
import { type EdenCall, edenBaseQuery } from "@/src/common/lib/eden-base-query";

type UpdateProfileResponse = App["~Routes"]["user"]["me"]["put"]["response"]["200"];

export const ownerProfileApi = createApi({
	reducerPath: "ownerProfileApi",
	baseQuery: edenBaseQuery(),
	endpoints: (builder) => ({
		updateOwnerProfile: builder.mutation<UpdateProfileResponse, UpdateUserPayload>({
			query:
				(payload): EdenCall<UpdateProfileResponse> =>
				(client) =>
					client.user.me.put(payload),
		}),
	}),
});

export const { useUpdateOwnerProfileMutation } = ownerProfileApi;
